/**
 * The single definition of "is this allowed". Used by ProtectedRoute for route
 * guarding and by the sidebar's role filter, so a menu item and its route can
 * never disagree about who may see it.
 */
export function canAccess(
  userRoles: readonly string[] | undefined,
  requiredRoles: readonly string[] | undefined,
): boolean {
  if (!requiredRoles || requiredRoles.length === 0) return true;
  if (!userRoles || userRoles.length === 0) return false;
  return requiredRoles.some((role) => userRoles.includes(role));
}
